import { useCallback, useContext } from 'react';
import { CanvasContext } from '../pages/Canvas/WorkflowCanvas';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import useCanvasStore from '../pages/Canvas/useCanvasStore';
import usePlaceholderTraceStore from './usePlaceholderTraceStore';
import { tracePlaceholder } from '../../utils/placeholderTrace';

const sharedRefsCache = new Map();

export function useTracePlaceholder(outputsByComponentArg) {
  const canvasCtx = useContext(CanvasContext);

  const onChipClick = useCallback((key, typeHint) => {
    if (!key) return;
    const store = usePlaceholderTraceStore.getState();
    if (store.activeKey === key) {
      store.clear();
      return;
    }
    const outputsByComponent =
      outputsByComponentArg ?? canvasCtx?.allPlaceholdersInWorkflow ?? {};
    const components = useProjectStore.getState().components || [];
    const edges = useCanvasStore.getState().edges || [];
    const result = tracePlaceholder(key, {
      components,
      edges,
      outputsByComponent,
      refsCache: sharedRefsCache,
    });
    if (typeHint) result.type = typeHint;
    store.setTrace(result);
  }, [outputsByComponentArg, canvasCtx]);

  return { onChipClick };
}

export default useTracePlaceholder;
